export default __webpack_public_path__ + "static/media/51.b8e3c305.png";